import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ConstructionServicesPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative h-80 flex items-center justify-center overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Construction Services</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Safe, efficient, and high-quality field execution
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Construction Services for <span className="text-red-600">Oil & Gas Projects</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed">
              Construction in the oil & gas sector demands precision, strict adherence to international standards, and seamless coordination between engineering, procurement, and field execution. Total Vision Oil and Gas Fields Services and Consultancy LLC SPC provides comprehensive construction services that ensure safe, efficient, and high quality delivery of upstream, midstream, and downstream facilities.
            </p>
          </div>

          {[
            {
              title: 'Construction Planning and Mobilization',
              items: ['Development of construction execution plans, method statements, and work front strategies', 'Mobilization of skilled manpower, equipment, and temporary facilities', 'Site surveys, constructability reviews, and logistics planning', 'Establishment of HSE systems, quality procedures, and site control measures']
            },
            {
              title: 'Civil and Structural Construction',
              items: ['Earthworks, grading, and site preparation', 'Construction of foundations for static and rotating equipment', 'Structural steel fabrication and erection', 'Construction of pipe racks, equipment shelters, and process buildings', 'Concrete works, paving, and infrastructure development']
            },
            {
              title: 'Mechanical and Piping Construction',
              items: ['Fabrication and installation of piping systems (carbon steel, stainless steel, alloy)', 'Installation of pressure vessels, heat exchangers, pumps, compressors, and tanks', 'Welding, NDT, hydrotesting, and mechanical integrity verification', 'Alignment, grouting, and commissioning support for rotating equipment']
            },
            {
              title: 'Electrical and Instrumentation Construction',
              items: ['Installation of electrical panels, transformers, switchgear, and MCCs', 'Cable laying, termination, testing, and commissioning', 'Installation of field instruments, control systems, and communication networks', 'Hazardous area installations in compliance with IEC/ATEX standards', 'Integration of DCS, ESD, F&G, and SCADA systems']
            },
            {
              title: 'Construction Management and Supervision',
              items: ['Daily supervision of field activities and contractor performance', 'Work front planning, progress tracking, and productivity monitoring', 'Interface management between engineering, procurement, and construction', 'Coordination with vendors, subcontractors, and client representatives', 'Implementation of quality control and inspection programs']
            },
            {
              title: 'HSE Leadership and Compliance',
              items: ['Implementation of project-specific HSE plans and risk assessments', 'Toolbox talks, safety inductions, and continuous workforce training', 'Monitoring of permit-to-work systems and safe work practices', 'Incident reporting, investigation, and corrective action implementation', 'Compliance with ADNOC, Aramco, and international safety standards']
            },
            {
              title: 'Pre Commissioning and Commissioning Support',
              items: ['System walkdowns, punch listing, and mechanical completion', 'Pressure testing, flushing, cleaning, and equipment energization', 'Loop checks, functional testing, and calibration', 'Support for start up teams and performance testing', 'Preparation of as built documentation and handover packages']
            }
          ].map((section, idx) => (
            <div key={idx} className="mb-16">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">{section.title}</h3>
              <div className="grid md:grid-cols-2 gap-4">
                {section.items.map((item, i) => (
                  <Card key={i} className="border-none shadow-lg">
                    <CardContent className="p-6">
                      <div className="flex items-start gap-3">
                        <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                        <span className="text-slate-700 text-base">{item}</span>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Why Construction Services Matter in Oil & Gas</h3>
            <p className="text-lg text-slate-700 leading-relaxed mb-8">
              High quality construction execution directly influences project safety, schedule, cost, and long term operational performance. With a disciplined approach and deep technical expertise, Total Vision Oil and Gas Fields Services and Consultancy LLC SPC ensures:
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {['Safe and compliant field execution', 'On time delivery of construction milestones', 'Seamless coordination with engineering and procurement', 'Reduced rework and optimized construction productivity', 'Reliable transition to commissioning and operations'].map((item, idx) => (
                <Card key={idx} className="border-none shadow-lg">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 text-base font-medium">{item}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConstructionServicesPage;